module.exports = __webpack_public_path__ + "static/media/WP-Snippet-03.8540b4cd.mp4";